import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Row, Col, Spinner, Form, Button } from "react-bootstrap";
import Card from "../../components/Card";
import MasterService from "../../services/master/MasterService";
import DataTable from "react-data-table-component";

const Pelabuhan = () => {
  const columns = useMemo(() => [
    {
      name: 'Kode Pelabuhan',
      selector: row => row.tbRPelabuhanPK?.kodePelabuhan,
      sortable: true
    },
    {
      name: 'Nama Pelabuhan',
      selector: row => row.uraianPelabuhan, 
      sortable: true
    },
    {
      name: 'Jenis Pelabuhan',
      selector: row => row.tbRPelabuhanPK?.jnsPelabuhan === 'D' ? 'Dalam Negeri' : 'Luar Negeri',
      sortable: true
    },
  ], []);

  const masterService = useMemo(() => new MasterService(), []);
  const [listPelabuhan, setListPelabuhan] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0); 
  const [size, setSize] = useState(10);
  const [totalData, setTotalData] = useState(0);

  const getlistPelabuhan = useCallback(async (page, size, keyword = "") => {
    setLoading(true);
    try {
      const response = await masterService.listPelabuhan(null, null, keyword, page, size);
      const data = response.data;
      setListPelabuhan(data.data);
      const total = parseInt(data.totalData);
      setTotalData(isNaN(total) ? 0 : Math.max(0, total));
    } catch (error) {
      console.error("🔥 Error fetching data:", error);
      setListPelabuhan([]);
      setTotalData(0);
    }
    setLoading(false);
  }, [masterService]);

  useEffect(() => {
    getlistPelabuhan(page, size, searchKeyword);
  }, [getlistPelabuhan, page, size, searchKeyword]);

  const handleSearchChange = (e) => {
    setSearchKeyword(e.target.value);
    setPage(0);
  };

  const handleResetSearch = () => {
    setSearchKeyword("");
    setPage(0); 
  };

const filteredData = useMemo(() => {
  const keyword = searchKeyword.toLowerCase();
  return listPelabuhan.filter((item) => {
    const kode = item.tbRPelabuhanPK?.kodePelabuhan?.toLowerCase() || "";
    const jenis = item.tbRPelabuhanPK?.jnsPelabuhan === 'D' ? 'dalam negeri' : 'luar negeri';
    const uraian = item.uraianPelabuhan?.toLowerCase() || "";

    return (
      kode.includes(keyword) ||
      jenis.includes(keyword) ||
      uraian.includes(keyword)
    );
  });
}, [listPelabuhan, searchKeyword]);


  return (
    <Row>
      <Col sm="12">
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Pencarian Data</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="align-items-end">
                <Col sm="4">
                  <Form.Group>
                    <Form.Control
                      type="text"
                      placeholder="Cari Nama Pelabuhan"
                      value={searchKeyword}
                      onChange={handleSearchChange}
                    />
                  </Form.Group>
                </Col>
                <Col sm="2">
                  <Button
                    variant="secondary"
                    className="w-100"
                    onClick={handleResetSearch}
                  >
                    Reset
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Daftar Master Pelabuhan</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className="table-responsive border-bottom my-3">
              {loading ? (
                <Spinner animation="border" />
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredData}
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationTotalRows={totalData}
                  paginationPerPage={size}
                  paginationDefaultPage={page + 1}
                  onChangePage={(newPage) => setPage(newPage - 1)}
                  onChangeRowsPerPage={(newSize, newPage) => {
                    setSize(newSize);
                    setPage(newPage - 1);
                  }}
                  persistTableHead
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: "#00acee",
                        color: "white",
                      },
                    },
                  }}
                />
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Pelabuhan;
